/**
 * Roles class
 */

export class Rol {
    id: number;
    name: string;
}

export enum Roles {
    ADMIN_ROLE = 'Administrador',
    LEADER_ROLE = 'Responsable',
    SUPER_LEADER_ROLE = 'Director',
    USER_ROLE = 'Usuario'
}